'use client';

import { MetaDefault } from '../../components/typography';
import { Badge } from '../../components/badge';
import { Field } from '../../components/field';
import { IconButton } from '../../components/icon-button';
import { Input } from '../../components/input';
import { HStack, Wrap } from '@terra/ui-styled-system';
import { Cancel01Icon } from '@terra/ui-icons';
import { useState } from 'react';
import { useTranslations } from 'next-intl';

type EndpointGlobsFieldProps = {
  value: string[];
  onChange: (next: string[]) => void;
  errorMessage?: string;
};

export const EndpointGlobsField = ({
  value,
  onChange,
  errorMessage,
}: EndpointGlobsFieldProps) => {
  const t = useTranslations('designSystem.testingInstructions');
  const tCommon = useTranslations('designSystem.common');
  const [globDraft, setGlobDraft] = useState('');
  const addGlob = () => {
    const next = globDraft.trim();

    if (!next) return;
    if (!value.includes(next)) {
      onChange([...value, next]);
    }

    setGlobDraft('');
  };

  return (
    <Field.Root w="full" invalid={!!errorMessage}>
      <Field.Label>{t('form.endpointGlobs')}</Field.Label>
      <Field.HelperText>{t('form.endpointGlobsHelper')}</Field.HelperText>
      <Input
        value={globDraft}
        onChange={(event) => setGlobDraft(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            addGlob();
          }
        }}
        placeholder={t('form.endpointGlobsPlaceholder')}
        size="sm"
        borderColor={errorMessage ? 'border.error' : undefined}
      />
      {value.length > 0 ? (
        <Wrap gap={2} mt={2}>
          {value.map((glob) => (
            <Badge key={glob} variant="outline" size="sm">
              <HStack gap={1} alignItems="center">
                <MetaDefault>{glob}</MetaDefault>
                <IconButton
                  size="xs"
                  variant="ghost"
                  aria-label={tCommon('delete')}
                  onClick={() =>
                    onChange(value.filter((item) => item !== glob))
                  }
                >
                  <Cancel01Icon size={12} />
                </IconButton>
              </HStack>
            </Badge>
          ))}
        </Wrap>
      ) : null}
      {errorMessage ? <Field.ErrorText>{errorMessage}</Field.ErrorText> : null}
    </Field.Root>
  );
};
